import './bootstrap';
import {afterComponentLoadBootstrap} from "./bootstrap";
import {initPublicTicketsIndex} from "./tickets";
import {initPublicCalendarIndex} from "./calendar";

const componentMap = {
    'public.tickets.index': {
        action: initPublicTicketsIndex
    },
    'public.calendar.index': {
        action: initPublicCalendarIndex
    },
};

document.addEventListener('DOMContentLoaded', () => {
    // Init components
    // noinspection JSUnresolvedReference
    if (window.jsComponents) {
        window.jsComponents.forEach(componentKey => {
            if (componentMap[componentKey]) {
                componentMap[componentKey].action();
            } else {
                console.error(`"${componentKey}" component not found`);
            }
        })
    }

    afterComponentLoadBootstrap()
})
